import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type {
  AusfallarbeitTimeSeriesQueryParams,
  AusfallarbeitTimeSeriesResponse
} from "../RevenueMonitoring.types";

export function useAusfallarbeitTimeSeries(
  generatorIds: AusfallarbeitTimeSeriesQueryParams["generator_ids"],
  firstDate: AusfallarbeitTimeSeriesQueryParams["first_date"],
  lastDate: AusfallarbeitTimeSeriesQueryParams["last_date"] | null | undefined,
  abregler?: AusfallarbeitTimeSeriesQueryParams["abregler"]
) {
  const sortedIds = [...generatorIds].sort();

  return useQuery({
    queryKey: [
      "ausfallarbeitTimeSeries",
      { generatorIds: sortedIds, firstDate, lastDate, abregler }
    ],
    queryFn: lastDate
      ? () =>
          fetchAusfallarbeitTimeSeries(sortedIds, firstDate, lastDate, abregler)
      : skipToken,
    enabled: sortedIds.length > 0,
    retry: false
  });
}

async function fetchAusfallarbeitTimeSeries(
  generatorIds: AusfallarbeitTimeSeriesQueryParams["generator_ids"],
  firstDate: AusfallarbeitTimeSeriesQueryParams["first_date"],
  lastDate: AusfallarbeitTimeSeriesQueryParams["last_date"],
  abregler?: AusfallarbeitTimeSeriesQueryParams["abregler"]
) {
  const url = urls.apiWithoutCamelization.ausfallarbeitTimeSeries({
    generator_ids: generatorIds,
    first_date: firstDate,
    last_date: lastDate,
    abregler
  });
  const response =
    await apiWithoutCamelization.get<AusfallarbeitTimeSeriesResponse>(url);
  return response.data;
}
